<template>
  <b-container>
    <b-row>
      <b-col>
        <div class="search-form">
          <label for="search-input" class="sr-only">Search text</label>
          <label for="search-type-select" class="sr-only"
            >Search category</label
          >
          <b-input-group>
            <b-form-input
              id="search-input"
              v-model="searchText"
              placeholder="Enter search text"
              autocomplete="off"
              @keyup.enter="goSearch()"
              @input="validationError = null"
              :state="validationError ? false : null"
              class="custom-input-width"
            ></b-form-input>
            <b-input-group-append>
              <b-form-select
                id="search-type-select"
                v-model="selectedSearchType"
                :options="searchTypes"
                class="custom-select-width"
                autocomplete="off"
              ></b-form-select>
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                @click="goSearch()"
                variant="primary"
                aria-label="Search"
              >
                <b-icon icon="search"></b-icon>
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <b-form-invalid-feedback
            :state="validationError ? false : null"
            class="mt-1"
          >
            {{ validationError }}
          </b-form-invalid-feedback>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import FormSection from "../../components/common/FormSection.vue";
export default {
  name: "GeneralSearch",
  components: {
    FormSection,
  },
  data() {
    return {
      searchText: null,
      lastSearchText: null,
      validationError: null,
      searchTypes: [
        { text: "Gene", value: "genes" },
        { text: "Clone", value: "dna" },
        { text: "Keyword", value: "keyword" },
        { text: "Protein", value: "protein" },
        { text: "Polymorphisms", value: "polyallele" },
        { text: "Ecotype", value: "ecotype" },
        { text: "Person", value: "community" },
        { text: "Germplasm", value: "germplasm" },
        { text: "Marker", value: "markers" },
        { text: "Vector", value: "vector" },
        { text: "Transposon", value: "transposon" },
        // { text: "Exact Name Search", value: "exact_name_search" },
      ],
      selectedSearchType: "genes",
      searchAlreadyShown: false,
    };
  },
  methods: {
    goSearch() {
      const trimmed = (this.searchText || "").trim();
      if (trimmed.length === 0) {
        this.validationError = "Please enter a search term.";
        return;
      }
      // Only community (Person) search hits Oracle directly; a 1-char contains
      // scan there is a full table scan. Other categories still go through
      // SOLR, where short prefixes are cheap — keep them unrestricted so
      // short gene names like "W" still work.
      if (
        this.selectedSearchType === "community" &&
        trimmed.length < 2
      ) {
        this.validationError =
          "Please enter at least 2 characters to search for a person.";
        return;
      }
      this.validationError = null;
      this.$nextTick(() => {
        if (this.$route.path !== "/results") {
          this.searchAlreadyShown = false;
        }
        this.$router.push({
          path: "/results",
          query: {
            mainType: "general",
            searchText: trimmed,
            category: this.selectedSearchType,
          },
        });
        this.searchText = "";
      });
    },
  },
};
</script>
<style scoped>
.search-form {
  width: 100%;
  max-width: 100%;
}

.b-input-group {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
}

.custom-input-width {
  flex: 1 1 auto;
  min-width: 120px;
  max-width: 100%;
}

.custom-select-width {
  flex: 0 1 auto;
  min-width: 100px;
  max-width: 100%;
}

/* Adjust width for screens smaller than 768px */
@media (max-width: 767px) {
  .b-input-group {
    flex-direction: column;
  }
  .custom-input-width,
  .custom-select-width {
    width: 100%;
    max-width: 100%;
    flex: 1 1 100%;
  }
  .custom-select {
    font-size: 13px;
  }
}

/* Specific handling for 320px viewport (WCAG reflow) */
@media (max-width: 480px) {
  .custom-input-width {
    min-width: 0;
    flex: 1 1 100%;
  }

  .custom-select-width {
    min-width: 0;
    flex: 1 1 100%;
  }
}

.input-group-prepend .input-group-text label {
  margin: 0;
}

/* Screen reader only class for accessibility */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
